import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { CreateBrandRequest } from '../../api/requests/brand-request.ts';
import { createBrand } from '../../api/brand.ts';

export default function useCreateBrand(): UseMutationResult<
  Awaited<ReturnType<typeof createBrand>>,
  Error,
  CreateBrandRequest
> {
  return useMutation({
    mutationFn: createBrand,
  });
}
